import React from "react";
import PropTypes from "prop-types";
import { DateRangePicker } from "react-dates";
import moment from "moment";
import { Row, Col } from "react-bootstrap";

import DepartmentSelect from "../../common/DepartmentSelect";
import UserSelect from "../../common/UserSelect";
import EmploymentStatusSelect from "../../common/EmploymentStatusSelect";

import ReportFilters from "../ReportFiltersComponent";

const Filters = ({
  onChange,
  filters,
  onChangeDate,
  focusedInput,
  onFocusChange,
  fetchData,
  handleResetFilters,
  loading,
  onExportClick,
  exportDisabled
}) => (
  <ReportFilters
    onFetchClick={fetchData}
    onResetClick={handleResetFilters}
    title="PTO Balance"
    loading={loading}
    csvExportAvailable
    onCSVExport={onExportClick}
    exportDisabled={loading || exportDisabled}
  >
    <Row>
      <Col md={3}>
        <DepartmentSelect
          placeholder="Select"
          label="Department"
          isMulti
          onChange={onChange("department")}
          value={filters.department || []}
        />
      </Col>
      <Col md={3}>
        <UserSelect
          placeholder="Select"
          label="User"
          isMulti
          selectedDepartment={filters && filters.department}
          onChange={onChange("_id")}
          value={filters._id || []}
        />
      </Col>
      <Col md={3}>
        <UserSelect
          isMulti
          placeholder="Select"
          label="Manager"
          onChange={onChange("manager")}
          value={filters.manager || []}
        />
      </Col>
      <Col md={3}>
        <EmploymentStatusSelect
          placeholder="Select"
          label="Employment Status"
          value={filters.employment_status || []}
          onChange={onChange("employment_status")}
          isMulti
        />
      </Col>
    </Row>
    <Row>
      <Col md={3}>
        <label className="control-label" style={{ textTransform: "uppercase" }}>
          Date Range
        </label>
        <DateRangePicker
          startDate={filters.start_date ? moment(filters.start_date) : null}
          startDateId="startDate"
          endDate={filters.end_date ? moment(filters.end_date) : null}
          endDateId="endDate"
          onDatesChange={({ startDate, endDate }) => {
            onChangeDate(startDate, endDate);
          }}
          isOutsideRange={() => false}
          focusedInput={focusedInput}
          onFocusChange={onFocusChange}
        />
      </Col>
    </Row>
  </ReportFilters>
);
Filters.propTypes = {
  onChange: PropTypes.func,
  onChangeDate: PropTypes.func,
  filters: PropTypes.object,
  focusedInput: PropTypes.node,
  onFocusChange: PropTypes.func,
  fetchData: PropTypes.func,
  handleResetFilters: PropTypes.func,
  loading: PropTypes.bool,
  onExportClick: PropTypes.func,
  exportDisabled: PropTypes.bool
};

Filters.defaultProps = {
  onChangeDate: () => null,
  filters: {}
};

export default Filters;
